import { useCallback, useEffect, useMemo } from "react";

export const useFetchResource = ({ fetch: _fetch, state, type }) => {
    const {
        pagination: { pageIndex, pageSize },
        sorting: sortBy,
        columnFilters,
        additionalParams,
    } = state;

    const filters = useMemo(
        () =>
            columnFilters.filter((filter) => {
                if (Array.isArray(filter.value) && filter.value.length === 0) {
                    return false;
                }
                if (filter.value === "") {
                    return false;
                }
                return true;
            }),
        [columnFilters]
    );

    const fetch = useCallback(async (controller) => {
        return _fetch({ pageIndex, pageSize, filters, sortBy, type, includeGroupings: additionalParams?.includeGroupings }, controller);
    }, [_fetch, pageIndex, pageSize, filters, sortBy, type, additionalParams?.includeGroupings]);

    useEffect(() => {
        const controller = new AbortController();
        fetch(controller);
        return () => controller.abort();
    }, [fetch]);

    return fetch;
};
